import { useEffect, useState } from "react";

function Timer({ duration = 60, onComplete }) {
    const [secondsLeft, setSecondsLeft] = useState(duration);

    useEffect(() => {
        const timer = setInterval(() => {
            setSecondsLeft((prev) => {
                if (prev === 1) {
                    clearInterval(timer);
                    if (onComplete) onComplete();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [onComplete]);

    return <span>{secondsLeft}</span>;
}

export default Timer;
